import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
export default function InputContainer({ style, label, message, children, className = '', containerRef, }) {
    var _a, _b, _c;
    const [size, setSize] = React.useState((_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.size);
    const [disabled, setDisabled] = React.useState(((_b = children === null || children === void 0 ? void 0 : children.props) === null || _b === void 0 ? void 0 : _b.disabled) || false);
    const [mode, setMode] = React.useState((_c = children === null || children === void 0 ? void 0 : children.props) === null || _c === void 0 ? void 0 : _c.mode);
    React.useEffect(() => {
        setMode(children.props.mode);
        setSize(children.props.size);
        setDisabled(children.props.disabled);
    }, [children.props.mode, children.props.size, children.props.disabled]);
    return (_jsxs(Container, { className: `${className} ui-input-container`, size: size, mode: mode, style: style, disabled: disabled, ref: containerRef, children: [_jsx("label", { children: label }), children, typeof message !== 'undefined' && _jsx("div", { className: "ch-hint-message", children: _jsx(_Fragment, { children: message }) })] }));
}
;
export const Container = styled.div `
  position: relative;
  text-align: left;
  flex: 1;

  & label {
    display: inline-block;
    margin-bottom: var(--ui-label-margin-bottom-medium);
    font-weight: 500;
    font-size: var(--ui-label-font-size-medium);
    line-height: var(--ui-label-line-height-medium);

    ${props => props.size === 'big' && css `
      margin-bottom: var(--ui-label-margin-bottom-big);
      font-size: var(--ui-label-font-size-big);
      line-height: var(--ui-label-line-height-big);
    `}

    ${props => props.size === 'small' && css `
      margin-bottom: var(--ui-label-margin-bottom-small);
      font-size: var(--ui-label-font-size-small);
      line-height: var(--ui-label-line-height-small);
    `}

    color: var(--ui-label-color);
    user-select: none;

    ${props => props.disabled && css `
      opacity: 0.37;
    `}
  }

  & .ch-hint-message {
    display: inline-flex;
    position: relative;
    align-items: center;
    min-height: 0.75rem;
    margin-top: var(--ui-hint-margin-medium);
    padding: var(--ui-hint-padding-v) var(--ui-hint-padding-h);
    border-radius: var(--ui-hint-border-radius-medium);
    font-size: var(--ui-hint-font-size-medium);
    line-height: 1;
    color: var(--text-secondary);

    ${props => props.size === 'big' && css `
      font-size: var(--ui-hint-font-size-big);
      margin-top: var(--ui-hint-margin-big);
      border-radius: var(--ui-hint-border-radius-big);
      min-height: var(--ui-hint-font-size-big);
    `}

    ${props => props.size === 'small' && css `
      font-size: var(--ui-hint-font-size-small);
      margin-top: var(--ui-hint-margin-small);
      border-radius: var(--ui-hint-border-radius-small);
      min-height: var(--ui-hint-font-size-small);
    `}

    ${props => props.mode === 'error' && css `
      color: var(--ui-hint-error-color);
      background: var(--ui-hint-error-background);
    `}

    ${props => props.mode === 'warning' && css `
      color: var(--ui-hint-warning-color);
      background: var(--ui-hint-warning-background);
    `}

    & svg {
      margin-right: 0.25rem;
      width: 1rem;
      height: 1rem;
    }
  }
`;
